$ ->
  $('.pick-up-articles').slick()
